import { render, staticRenderFns } from "./browse-list.vue?vue&type=template&id=68d04e2e&scoped=true"
import script from "./browse-list.vue?vue&type=script&lang=js"
export * from "./browse-list.vue?vue&type=script&lang=js"
import style0 from "./browse-list.vue?vue&type=style&index=0&id=68d04e2e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d04e2e",
  null
  
)

export default component.exports